import { render } from "./Components.vue?vue&type=template&id=7e72e2f4&scoped=true"
import script from "./Components.vue?vue&type=script&lang=js"
export * from "./Components.vue?vue&type=script&lang=js"

import "./Components.vue?vue&type=style&index=0&id=7e72e2f4&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e72e2f4"],['__file',"src/assets/js/pages/Components.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e72e2f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e72e2f4', __exports__)) {
    api.reload('7e72e2f4', __exports__)
  }
  
  module.hot.accept("./Components.vue?vue&type=template&id=7e72e2f4&scoped=true", () => {
    api.rerender('7e72e2f4', render)
  })

}


export default __exports__